// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';

//import FileViewer from 'react-file-viewer';
import '../less/DocViewer.less';

import { Button, Icon } from 'antd';

import FileSaver from 'file-saver';
import MediaServices from '../services/media/Media';


export default class DocSpan extends Component {

  image_ext = ['jpg', 'jpeg', 'png'];
  token = localStorage.getItem('token');

  constructor(props) {
    super(props);
    this.state = {
      loading: true,

    };
  }




  downloadFile() {

    MediaServices.download(this.props.file.id, async (res) => {
      const blob = new Blob([res.data], { type: this.props.file.mime_type });
      let nome_file = this.props.file.nome_file.split('.');
      let ext = nome_file.pop();
      nome_file = nome_file.join('.');

      const today = new Date();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      const date = today.getDate();
      const hour = ('0' + today.getHours()).slice(-2);
      const minu = ('0' + today.getMinutes()).slice(-2);

      FileSaver.saveAs(blob, nome_file + `_${date}${month}${year}_${hour}${minu}.` + ext);

    }, () => null)
  }

  getTextStyle() {
    return this.props.file.deleted ? { color: 'red', width: 210, overflow:'hidden', textOverflow:'ellipsis' } : { width: 210, overflow:'hidden', textOverflow:'ellipsis'};
  }

  previewFile() {

    /*this.setState({open_modal: true});*/
    MediaServices.download(this.props.file.id, async (res) => {
      const blob = new Blob([res.data], { type: this.props.file.mime_type });

      var fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, '_blank');

    }, () => null)
  }


  render() {
    let preview = /*this.props.file.ext === 'pdf' ||*/ this.image_ext.indexOf(this.props.file.ext) !== -1;
    return <>
      <Button type="link" style={this.getTextStyle()} onClick={() => preview ? this.previewFile() : this.downloadFile()}>{(this.props.file.nome_file.split('_').join(' '))}</Button>
      {
        preview && <Icon type="download" style={{ fontSize: 18, marginLeft: 10, cursor: 'pointer' }} onClick={() => {
          this.downloadFile()
        }} />
      }
      {
        this.props.canRemove
          ?
          <Icon type="close" style={{ marginLeft: 10, cursor: 'pointer', color: 'red' }} onClick={() => {
            this.props.onRemove(this.props.file)
          }} />
          : null
      }
    </>
  }
}
